import { render, staticRenderFns } from "./ModalLinkMaterials.vue?vue&type=template&id=f2b61342&"
import script from "./ModalLinkMaterials.vue?vue&type=script&lang=js&"
export * from "./ModalLinkMaterials.vue?vue&type=script&lang=js&"
import style0 from "./ModalLinkMaterials.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports